import { useFeatureFlagEnabled } from '@posthog/react';

/** PostHog flag key gating Pothole/Field Notes selection in the CAD/GIS export picker. */
export const POTHOLE_FIELDNOTE_EXPORT_FLAG = 'pothole_fieldnote_available_in_cad_export_ui';

/**
 * Kill switch for offering Site Data (Potholes + Field Notes) in the export picker. Fail-closed:
 * `undefined`/`false` from PostHog (including while flags are still loading) hides the section.
 */
export function usePotholeFieldNoteExportEnabled(): boolean {
  return useFeatureFlagEnabled(POTHOLE_FIELDNOTE_EXPORT_FLAG) === true;
}
